import React, { useContext, useState } from 'react';
import { compose } from 'redux';
import noop from 'lodash/noop';
import { Cookies, withCookies } from 'react-cookie';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmDeleteDialog from '../statelessComponents/ConfirmDeleteDialog';
import history from '../../history';
import ContextProvider from '../../context';
import { logoutUser as logout } from '../../helpers/logout';

const UserPersonalityConfirmationDialog = ({
  isShown,
  handleSubmit,
  cookies,
  onClose,
  logoutBtnLabel,
  title,
  confirmBtnLabel,
}) => {
  const { organizationSlug, cookiePrefix } = useContext(ContextProvider);
  const dispatch = useDispatch();
  const locale = useSelector(state => state.intl.locale, shallowEqual);
  const [submitting, setSubmitting] = useState(false);

  const logoutUser = async () => {
    setSubmitting(true);

    await logout({
      cookiePrefix,
      cookiesInstance: cookies,
      dispatch,
    });

    onClose();
    history.replace(
      `/${locale}${organizationSlug ? `/${organizationSlug}` : ''}`,
    );
    setSubmitting(false);
  };

  return (
    <ConfirmDeleteDialog
      isShown={isShown}
      onClose={logoutUser}
      submit={handleSubmit}
      deleteBtnId="confirm-user-personality"
      submitColor="primary"
      deleteBtnLabel={confirmBtnLabel}
      title={title}
      cancelBtnLabel={logoutBtnLabel}
      disableBackdropClick
      isDeleting={submitting}
    />
  );
};

UserPersonalityConfirmationDialog.propTypes = {
  onClose: PropTypes.func,
  isShown: PropTypes.bool.isRequired,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  logoutBtnLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  confirmBtnLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
};
UserPersonalityConfirmationDialog.defaultProps = {
  onClose: noop,
};
export default compose(withCookies)(UserPersonalityConfirmationDialog);
